import React, {Component} from 'react';
import {ImageDisplayProperties} from '../../content/displayproperties/ImageDisplayProperties';

export default class ImageCell extends Component<ImageDisplayProperties> {
    override render() {
        return <img className={`image-container${this.props.border ? "--border" : ""}`}
                    src={this.props.url}
                    alt=""
                    title={this.props.description}
        />;
    }
}
